import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const SurveyEmbed = ({ surveyLink }) => {
    const [loading, setLoading] = useState(true);

    const handleIframeLoad = () => {
        setLoading(false);
    };

    return (
        <div>
            {loading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                    <CircularProgress />
                </Box>
            )}
            <iframe
                src={surveyLink}
                title="Survey"
                width="100%"
                height="100%"
                style={{ border: 'none', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: loading ? 'none' : 'block' }}
                onLoad={handleIframeLoad}
            />
        </div>
    );
};

export default SurveyEmbed;